import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import {
  PUBLIC_TEST_URL,
  PUBLIC_START_URL,
  FUTUREBILITY_COCKPIT_URL,
  FUTUREBILITY_COCKPIT_INDIVIDUAL_REPORT_URL,
} from "./constants";
import "./index.scss";
import { ParticipationFlow } from "./ParticipationFlow";
import { FuturebilityCockpit } from "./FuturebilityCockpit";
import { LanguageSelection } from "./LanguageSelection";
import { Demo } from "./ParticipationFlow/sub-pages/Demo";
import IndividualPdfReport from "./IndividualPdfReport";

function Frontend() {
  return (
    <Switch>
      <Route exact path="/">
        <Redirect to="/tool/" />
      </Route>
      <Route
        path={`${PUBLIC_START_URL}/:clientId`}
        component={LanguageSelection}
      />
      <Route
        path={`${PUBLIC_TEST_URL}/:testId/:sessionId/:module/:subPage?/:subStep?`}
        component={ParticipationFlow}
      />
      <Route
        path={`${FUTUREBILITY_COCKPIT_URL}/:clientId/start`}
        render={() => <LanguageSelection isCockpit />}
      />
      <Route
        path={`${FUTUREBILITY_COCKPIT_URL}/:clientId/:testId/:module?/:category?/:cubeSide?`}
        component={FuturebilityCockpit}
      />
      <Route
        path={`${FUTUREBILITY_COCKPIT_INDIVIDUAL_REPORT_URL}/:sessionId`}
        component={IndividualPdfReport}
      />
      <Route path={`/demo`} render={props => <Demo />} />
    </Switch>
  );
}

export default Frontend;
